import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Finalizing your booking...");

  useEffect(() => {
    const eventId = searchParams.get("eventId");
    const businessId = searchParams.get("businessId");
    
    // Ensure we only run this if we have an eventId
    if (!eventId) return;

    const completePayment = async () => {
      try {
        // 1. Update the database to 'paid'
        await axios.post(
          `${process.env.REACT_APP_API_URL}/events/update-payment-status`,
          { eventId, payment: "paid" },
          { withCredentials: true }
        );

        // 2. Generate the PDF invoice
        await axios.post(
          `${process.env.REACT_APP_API_URL}/event/generate-invoice`,
          { eventId },
          { withCredentials: true }
        );

        setStatus("Payment successful! Redirecting to your dashboard...");

        // 3. Redirect to the client home page
        setTimeout(() => {
          navigate(`/client-home?businessId=${businessId}`);
        }, 2000);

      } catch (error) {
        console.error("Error finalizing payment:", error);
        setStatus("Payment received, but there was an error updating your dashboard. Please contact support.");
      }
    };

    completePayment();
  }, [searchParams, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{status}</h2>
      <p>Please do not close this window.</p>
    </div>
  );
};

export default PaymentSuccess;